import { settingsActionTypes } from '../actions/settings-action-types';

const initialSettingsState = {};

const initialSettingsUpdateState = {};

export const settings = (state = initialSettingsState, action) => {
    switch(action.type) {
        case settingsActionTypes.SETTINGS_RECEIVED:
            return { ...state, ...action.settings };
        case settingsActionTypes.SETTINGS_REQUEST_FAILED:
            console.error(action.error);
            return state;
        default: //We don't do anything with inflight settings yet
            return state;
    }
};

export const settingsUpdate = (state = initialSettingsUpdateState, action) => {
    switch(action.type) {
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/settings/reducers/settings-reducers.js